import { ChevronDown } from "lucide-react";

export const GroupRow = ({ id, title, open, toggle, rows, cols, color, countOnly = false }) => {
  const pub = rows.filter((r) => (r.kit || r.product)?.published).length;
  const prog = rows.filter((r) => (r.kit || r.product) && !(r.kit || r.product).published).length;
  return (
    <tr data-testid={`group-${id}`} className="bg-stone-50/80 border-t border-stone-200 cursor-pointer select-none hover:bg-stone-100" onClick={toggle}>
      <td colSpan={cols} className="px-4 py-2.5">
        <span className="inline-flex items-center gap-2">
          <ChevronDown size={15} className={`text-stone-500 transition-transform duration-200 ${open ? "" : "-rotate-90"}`} />
          <span className="font-semibold text-sm" style={{ color }}>{title}</span>
          <span data-testid={`group-${id}-count`} className="text-xs text-stone-500">{rows.length}{!countOnly && <> · <b className="text-emerald-700 font-medium">{pub} published</b> · <b className="text-amber-700 font-medium">{prog} in progress</b></>}</span>
        </span>
      </td>
    </tr>
  );
};

export const ToggleAll = ({ onAll, prefix }) => (
  <span className="inline-flex gap-3 text-xs text-stone-500">
    <button data-testid={`${prefix}-expand-all`} onClick={() => onAll(true)} className="hover:text-stone-900">Expand all</button>
    <button data-testid={`${prefix}-collapse-all`} onClick={() => onAll(false)} className="hover:text-stone-900">Collapse all</button>
  </span>
);
